import { ClikResultVerdict } from "../../../../graphql/generated.ts";
import { toHumanReadable } from "../../../../utils/string.ts";

export const clikResultVerdictOptions = Object.values(ClikResultVerdict).map(
  (item) => ({
    value: item,
    label: toHumanReadable(item),
  })
);
